// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__VwUXX","green":"checkbox_green__qequK","danger":"checkbox_danger__z2lBY","disabled":"checkbox_disabled__ye0vR"};